/**
 * HTML Transformation Utilities
 *
 * This module provides functions to transform HTML content while preserving
 * special placeholders like {{ img_tag(N) }} and {{ code_editor(N) }}.
 */

/**
 * Replaces <pre class="code_editor"> tags with {{ code_editor(N) }} placeholders
 * while preserving {{ img_tag(N) }} placeholders during DOM parsing.
 *
 * This function:
 * 1. Temporarily replaces img_tag placeholders with safe markers
 * 2. Parses HTML with DOMParser to find code editor elements
 * 3. Replaces code editor elements with placeholders
 * 4. Restores the img_tag placeholders
 *
 * @param {string} htmlString - HTML string potentially containing code editor elements
 * @returns {string} HTML with code editors replaced by placeholders
 */
export const replacePreTags = (htmlString) => {
  // Preserve img_tag placeholders during DOM parsing
  // Store them temporarily with a safe marker
  const imgPlaceholders = [];
  let processedHtml = htmlString.replace(
    /\{\{\s*img_tag\((\d+)\)\s*\}\}/g,
    (match) => {
      const index = imgPlaceholders.length;
      imgPlaceholders.push(match);
      return `__IMG_PLACEHOLDER_${index}__`;
    }
  );

  const parser = new DOMParser();
  const htmlDoc = parser.parseFromString(processedHtml, "text/html");
  const preElements = htmlDoc.querySelectorAll("pre.code_editor");
  let counter = 0;

  preElements.forEach((pre) => {
    const replacementText = `{{ code_editor(${counter}) }}`;
    pre.outerHTML = replacementText;
    counter++;
  });

  let result = htmlDoc.body.innerHTML;

  // Restore img_tag placeholders
  imgPlaceholders.forEach((placeholder, index) => {
    result = result.replace(`__IMG_PLACEHOLDER_${index}__`, placeholder);
  });

  return result;
};
